<template>
  <el-row class="page" :gutter="24" style="padding-right: 24px;">
    <el-col :span="18">
      <el-card class="box-card">
        <div slot="header" class="clearfix header">
          <span>Количество билетов</span>
          <span class="subheader">Отчет по дням</span>
        </div>
        <apexchart
          type="bar"
          :options="chartOptions"
          :series="countSeries"
        ></apexchart>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix header">
          <span>Выручка</span>
          <span class="subheader">Отчет по дням</span>
        </div>
        <apexchart
          type="bar"
          :options="priceOptions"
          :series="priceSeries"
        ></apexchart>
      </el-card>
    </el-col>
  </el-row>
</template>

<script>
import moment from "moment-timezone";

moment.locale("ru");

export default {
  components: {},
  data: () => ({
    report: []
  }),
  computed: {
    priceOptions() {
      const opts = Object.assign({}, this.chartOptions);
      opts.chart.id = "report-day-price";
      //opts.xaxis.labels = { formatter: val => `${val} ₽` };
      opts.dataLabels = { formatter: val => `${val} ₽` };
      return opts;
    },
    chartOptions() {
      return {
        grid: {
          show: false
        },
        chart: {
          id: "report-day-count",
          height: "400px",
          toolbar: {
            show: false
          }
        },
        xaxis: {
          categories: this.report.map(e => moment(e.day).format("D MMM"))
        },

        plotOptions: {
          bar: {
            horizontal: true,
            endingShape: "rounded"
          }
        }
      };
    },
    countSeries() {
      return [
        {
          name: "Продано",
          data: this.report.map(e => e.count)
        }
      ];
    },
    priceSeries() {
      return [
        {
          name: "Выручка",
          data: this.report.map(e => e.price)
        }
      ];
    }
  },
  async created() {
    const report = await this.$axios.get(`/api/report/daily`);
    console.log(report.data.data.report);
    this.report = report.data.data.report;
  },
  mounted() {}
};
</script>

<style scoped>
.box-card {
  margin-bottom: 25px;
}
</style>
